import React from 'react';
import { useTranslation } from 'react-i18next';
import { DrawerModal } from '../../../../components/common';
import RequestAssistanceContent from './request-assistance-content';

/**
 * Standalone Request Assistance modal — opened from the dashboard widget.
 * No Back button (engineer-approved override from the HTML). The list modal instead
 * renders RequestAssistanceContent as an in-place view with its own Back header.
 */
const RequestAssistanceModal = ({ visible, onClose, unpostedCount = 0 }) => {
  const { t } = useTranslation();

  return (
    <DrawerModal
      visible={visible}
      onCancel={onClose}
      title={t('Request Assistance')}
      width={520}
      footer={null}
      destroyOnClose
    >
      {/* Dashboard-only: drop the footer's horizontal padding so Cancel/Send sit flush to the
          right edge of the modal body (no gap past the buttons). The list-modal assist view keeps
          the default footer padding. */}
      <RequestAssistanceContent
        unpostedCount={unpostedCount}
        onCancel={onClose}
        onSent={onClose}
        bodyPadding="20px 4px 28px"
        footerPadding="14px 0"
      />
    </DrawerModal>
  );
};

export default RequestAssistanceModal;
